import { useEffect, useState } from "react";
import { Card, Form, Button, Alert } from "react-bootstrap";
import { getOrg, getUsccbOrg, putDiocesis, putRegion } from "../../controllers/org";
import Loading from "../loading/Loading";
import { useAuth } from "../auth/AuthProvider";
import { Typeahead } from 'react-bootstrap-typeahead';

function CrearDiocesis({ org, onSuccess, defaultRegion }) {
  const [usccbDiocesis, setUsccbDiocesis] = useState(null);
  const [region, setRegion] = useState(defaultRegion?.region_id);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRegion, setIsLoadingRegion] = useState(false);
  const [alert, setAlert] = useState();
  const { token } = useAuth();
  const [regiones, setRegiones] = useState(org?.regiones);
  const [usccbOrg, setUsccbOrg] = useState();

  // const options = [
  //   { id: 'opt1', label: 'Option 1', value: 'value1' },
  //   { id: 'opt2', label: 'Option 2', value: 'value2' },
  //   { id: 'opt3', label: 'Option 3', value: 'value3' },
  // ];

  useEffect(() => {
    if (!regiones) {
      loadOrg();
    }
    loadUsccbOrg();
  }, []);

  useEffect(() => {
    if (org) {
      setRegiones(org.regiones);
    }
  }, [org]);

  async function loadOrg(){
    let o = await getOrg();
    setRegiones(o.regiones);
  }
  async function loadUsccbOrg(){
    let o = await getUsccbOrg();
    setUsccbOrg(o);
  }
  const filterBy = () => true;

  async function submit(e) {
    e.preventDefault();
    setIsLoading(true);
    let a;
    try {
      const r = await putDiocesis(`${usccbDiocesis[0].label}, ${usccbDiocesis[0].state_code}`, region, usccbDiocesis[0].usccb_diocese_id, token);
      a = <Alert key='alert' variant='success' dismissible>Se creó la diócesis <b>{usccbDiocesis[0].label}</b> con éxito.</Alert>;
      setUsccbDiocesis();
      setRegion();
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    }
    catch (e) {
      a = <Alert key='alert' variant='danger' dismissible>Error al crear diócesis.<br/><br/>{e.message}.</Alert>;
    }
    setIsLoading(false);
    if (a) {
      setAlert(a);
    }
  }

  function generateRegionOptions(){
    return regiones.map((it, idx) => {
      return <option value={it.region_id} key={'crear-diocesis-region-option-' + it.region_id}>{it.label}</option>;
    });
  }

  if (isLoading) {
    return <Card>
      <Card.Header>Crear Diócesis</Card.Header>
      <Card.Body><Loading text="Creando diócesis..." /></Card.Body>
    </Card>
  }
  if (!usccbOrg) {
    return <Card>
      <Card.Header>Crear Diócesis</Card.Header>
      <Card.Body><Loading text="Cargando..." /></Card.Body>
    </Card>
  }

  return <Card className="crear-org crear-diocesis">
    <Card.Header>Crear Diócesis en FAMA</Card.Header>
    <Card.Body>
      { alert }
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Diócesis de USCCB</Form.Label>
          <Typeahead
            id="async-region"
            labelKey="label"
            onChange={(selected) => {
              console.log(selected);
              setUsccbDiocesis(selected);
            }}
            options={usccbOrg.usccbDiocesis}
            placeholder="Selecciona la diócesis"
            renderMenuItemChildren={(option) => (
                <span>{option.label}, {option.state_code}</span>
            )}
            selected={usccbDiocesis}
          />
        </Form.Group>
        { !defaultRegion && <Form.Group className="mb-3">
          <Form.Label>Región</Form.Label>
          <Form.Select onChange={e => setRegion(parseInt(e.target.value))} defaultValue={region}>
            <option value={null}>-- Selecciona una región --</option>
            {generateRegionOptions()}
          </Form.Select>
        </Form.Group>}
        {!!usccbDiocesis && !!region && <Form.Group className="mb-3 submit-buttons-wrapper">
          <Button key='submit-btn-new-diocesis' type='submit' variant='primary' onClick={submit}>Guardar diócesis</Button>
        </Form.Group>}
      </Form>
    </Card.Body>
  </Card>
}

export default CrearDiocesis;
